import BaseFullscreenModal from './FullscreenModal';

// EXPORT
export const FullscreenModal = BaseFullscreenModal;
export type { FullscreenModalProps } from './FullscreenModal.interface';
